import { render, staticRenderFns } from "./CButtonGroup.vue?vue&type=template&id=3b251baa&scoped=true"
import script from "./CButtonGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./CButtonGroup.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CButtonGroup.vue?vue&type=style&index=0&id=3b251baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b251baa",
  null
  
)

export default component.exports